module.exports = __webpack_public_path__ + "img/code-guy-dark.d88a46b2.svg";